var map = {
	"./ai.png": 8178,
	"./banner.png": 3250,
	"./class_room/c1.png": 9211,
	"./class_room/c2.png": 5712,
	"./class_room/c3.jpg": 2017,
	"./class_room/c4.jpg": 9106,
	"./class_room/c5.jpg": 5455,
	"./class_room/c6.jpg": 4144,
	"./course/exam.png": 8457,
	"./course/kids.png": 4715,
	"./course/senior.png": 8691,
	"./css/main.css": 946,
	"./exam.png": 9545,
	"./images/logo_transparent.png": 3373,
	"./kids.png": 7275,
	"./logo.png": 3153,
	"./q1.jpg": 1614,
	"./q2.jpg": 1209,
	"./sakura/s1.png": 9759,
	"./sakura/s2.png": 615,
	"./sakura/s3.png": 2926,
	"./sakura/s4.png": 5393,
	"./sakura/s5.png": 5448,
	"./senior.png": 4192
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;